module.exports = __webpack_public_path__ + "static/media/tab_shape_bg.f0823274.png";